export default "__VITE_ASSET__89fee894__"